import { useMemo } from 'react';
import cross from '~/assets/icons/cross.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { IExchangeItemMoney, rage, useObservable } from '~/rage';
import { Currency, ExchangeItemType, WalletType } from '~/shared';
import {
	StyledCloseButtonContainer,
	StyledContainer,
	StyledDot,
	StyledMoneyContainer,
	StyledRightContainer,
} from './Head.styled';

const Head = () => {
	const donateBalance = useObservable(rage.bank.getBalance(WalletType.Donate));
	const ownedItems = useObservable(rage.exchange.getOwnedItems());
	const balance = useMemo(
		() =>
			(
				ownedItems.find(
					(item) => item.type === ExchangeItemType.Money,
				) as IExchangeItemMoney
			)?.amount || 0,
		[ownedItems],
	);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const donateIcon = useWalletIcon(Currency.Donate, true);

	return (
		<StyledContainer>
			<Text style={{ fontSize: 22, color: '#ffffff' }}>Обмен имуществом</Text>
			<StyledRightContainer>
				<StyledMoneyContainer>
					<Text style={{ color: '#FFC100' }}>
						{donateBalance.toLocaleString('ru-RU')}
					</Text>
					<CurrencyIcon icon={donateIcon} size="lg" />
					<StyledDot />
					<Text style={{ color: '#ffffff' }}>
						{balance.toLocaleString('ru-RU')}
					</Text>
					<CurrencyIcon icon={rubleIcon} size="lg" />
				</StyledMoneyContainer>
				<StyledCloseButtonContainer
					onClick={() => {
						rage.exchange.exitExchange();
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					<img src={cross} />
				</StyledCloseButtonContainer>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Head };
